// extracted by mini-css-extract-plugin
export default {"centered":"Footer_centered__mKQy6","icon":"Footer_icon__JfdXy","discordBtn":"Footer_discordBtn__eHLNG","main_footer":"Footer_main_footer__8mozj","footer":"Footer_footer__cmysn"};